module.exports = __webpack_public_path__ + "img/close-white.40244410.svg";